import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import time2TimeAgo from "../../utils/Helpers";
import Header from "../Header";
import ThemeContext, { AppTheme } from "../../context/ThemeContext";

const API_URL = "https://hacker-news.firebaseio.com/v0/";
const Detail = props => {
  const [story, setStory] = useState({});
  const theme = useContext(ThemeContext)[0];
  const currentTheme = AppTheme[theme];
  document.body.style.backgroundColor = currentTheme.background;
  document.body.style.color = currentTheme.foreground;
  const fetchStory = async storyId => {
    try {
      const response = await axios.get(`${API_URL}item/${storyId}.json`);
      setStory(response.data);
      console.log(response.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchStory(props.id);
  }, []);
  return (
    <div>
      <Header />
      <div className="detail-wrapper">
        <div>{story.title}</div>
        <div className="label">
          {story.by} | {time2TimeAgo(story.time)}
        </div>
        <div className="story-text" dangerouslySetInnerHTML={{ __html: story.text }} />
      </div>
    </div>
  );
};

export default Detail;
